var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!!_vm.item)?_c('ViewVehicle',{on:{"success":_vm.alertSuccess}}):_vm._e(),_c('fleet-table',{ref:"table",attrs:{"title":"Users"},on:{"addVehicle":_vm.showVehicleModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }